import { IBriefFormHistoryEntry } from "@shared/lib/types/briefCampains";
import { Popover } from "@shared/ui";
import { History } from "lucide-react";
import styles from "../styles.module.scss";

interface BriefHistoryPopoverProps {
  history: IBriefFormHistoryEntry[];
}

export function BriefHistoryPopover({ history }: BriefHistoryPopoverProps) {
  if (history.length === 0) return null;

  return (
    <Popover
      content={
        <div className={styles.historyPopover}>
          <h5 className={styles.historyTitle}>Edit History</h5>
          <div className={styles.historyList}>
            {[...history].reverse().map((event, i) => (
              <div key={i} className={styles.historyItem}>
                <div className={styles.historyAction}>
                  {event.name || "Updated"}
                </div>
                {event.remarks && event.remarks.length > 0 && (
                  <div className={styles.historyBlock}>
                    <ul className={styles.historyRemarksList}>
                      {event.remarks.map((remark, remarkIndex) => (
                        <li key={remarkIndex}>{remark}</li>
                      ))}
                    </ul>
                  </div>
                )}
                <div className={styles.historyMeta}>
                  {event.user
                    ? `${event.user.firstName} ${event.user.lastName}`
                    : event.userModelName || "System"}{" "}
                  •{" "}
                  {new Date(event.createdOn).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      }
      trigger="hover"
      placement="bottomLeft"
      overlayClassName={styles.historyPopoverOverlay}
    >
      <button type="button" className={styles.historyButton}>
        <History size={18} />
      </button>
    </Popover>
  );
}
